import {
  OfflineCurrentCustomerMetadata,
  OfflineTaskPayloadMap,
  OfflineTaskResultMap,
  OfflineTaskType,
} from '@zonofi/zono-money-store';
import { offlineQueue } from './offline-queue';

type WithPayload<T extends OfflineTaskType> = {
  payload: OfflineTaskPayloadMap[T];
  updater?: never;
};

type WithUpdater<T extends OfflineTaskType> = {
  payload?: never;
  updater: (
    prev: OfflineTaskPayloadMap[T] | undefined
  ) => OfflineTaskPayloadMap[T];
};

export type ExecuteOrQueueTaskInput<
  T extends OfflineTaskType = OfflineTaskType,
> = {
  type: T;
  customer?: OfflineCurrentCustomerMetadata;
  onSuccess?: (data?: OfflineTaskResultMap[T]) => void;
  entityKey?: string;
} & (WithPayload<T> | WithUpdater<T>);

export const addTaskToQueue = async ({
  type,
  customer,
  payload,
  updater,
  onSuccess,
  entityKey: uniqueKey,
}: ExecuteOrQueueTaskInput) => {
  const updaterFn = updater ?? (() => payload);
  const entityKey =
    uniqueKey ??
    `${type.toLowerCase()}:${customer?.customerId ?? Date.now().toString()}`;

  await offlineQueue.enqueueOrUpdate(type, entityKey, updaterFn, customer);
  onSuccess?.();
};

interface RemoveTaskFromQueueInput {
  type: OfflineTaskType;
  customerId: string;
}

export const removeTaskFromQueue = async ({
  type,
  customerId,
}: RemoveTaskFromQueueInput) => {
  const queue = offlineQueue.getSnapshot();
  const task = queue.find(
    (t) => t.type === type && t.customerMetadata?.customerId === customerId
  );
  if (task) {
    await offlineQueue.removeTaskById(task.id);
  }
};
